import { Injectable } from '@angular/core';
import { GlobalAiBackendService } from './global-ai-backend.service';
import { AbstractAiService } from '../../ai/abstract-ai.service';
import { Observable } from 'rxjs';
import { GlobalAiDebugInfoDto, GlobalAiRequestDto } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class GlobalAiService extends AbstractAiService {
  constructor(protected backend: GlobalAiBackendService) {
    super(backend);
  }

  /**
   * Fetches debug information for the given selectors data.
   * This is called separately from the main request flow,
   * when a user clicks a "Show Details" button.
   */
  getDebugInfo(request: GlobalAiRequestDto): Observable<GlobalAiDebugInfoDto> {
    return this.backend.getDebugInfo(request);
  }
}
